<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1361.9 777.9"
    style="enable-background: new 0 0 1361.9 777.9"
    xml:space="preserve"
    aria-hidden="true"
    preserve-aspect-ratio="xMidYMax slice"
  >
    <path
      d="M1212.9 254.7S1128.1-72 594.6 14.6c-109.2 17.8-178 60.9-254.5 115.7-84.8-23.1-189.3-48.2-291.7 46.5-62.7 57.9-67.6 158.5 3.9 228.1-98.6 342.1 614.2 516 951.2 227.2 42.7 25 180 63.5 290.3-43 191.1-216.8-80.9-334.4-80.9-334.4z"
      style="fill: #0d73ff"
    />
  </svg>
</template>
